import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import { store } from './store';
import GlobalStyles from './styles/GlobalStyles';
import { getUTMParameters, saveUTMParameters, hasUTMParameters } from './utils/utmUtils';

import MainLayout from './layouts/MainLayout';
import QuizPage from './pages/QuizPage';
import NotFoundPage from './pages/NotFoundPage';

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 minute
    },
  },
});

const App: React.FC = () => {
  // Capture UTM parameters when the app loads
  useEffect(() => {
    if (hasUTMParameters()) {
      const utmData = getUTMParameters();
      saveUTMParameters(utmData);
    }
  }, []);

  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename='/'>
          <GlobalStyles />
          <Routes>
            <Route path="/" element={<MainLayout />}>
              <Route index element={<QuizPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </Provider>
  );
};

export default App;
